<template>
  <div class="pie-echart">
    <my-echarts :eWidth="120" :eHight="120" :option="options" />
    <div class="name">总篮板</div>
    <div class="score-vs">
      <div class="score-item" style="border-right: 1px solid #C4C4C4;">
        <div>50</div>
        <div>54.3%</div>
      </div>
      <div class="score-item">
        <div>42</div>
        <div>54.3%</div>
      </div>
    </div>
  </div>
</template>

<script>
import myEcharts from '@comm/components/modal/myecharts/MyEcharts.vue'
export default {
  name: 'BasketballPieEchart',
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  components: { myEcharts },
  mounted() {},
  methods: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.pie-echart {
  width: 140px;
  display: flex;
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  .name {
    width: 120px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
  }
  .score-vs {
    width: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    .score-item {
      width: 50%;
      height:46px;
      margin-top: 10px;
      text-align: center;
      div:first-child{
        font-size: 24px;
        font-weight: bold;
        line-height: 26px;
      }
      div:last-child{
        font-weight: bold;
        color: #999;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballPieEchart.vue